"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  opacity: ", ";\n  transition: opacity 0.25s linear;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  > :first-child {\n    font-size: ", ";\n  }\n  > :last-child {\n    margin-left: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  animation: ", " 1s infinite linear;\n  &::before {\n    position: absolute;\n    display: block;\n    content: ' ';\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    box-sizing: border-box;\n    border-radius: 50%;\n    border: solid currentColor ", ";\n    opacity: 0.25;\n  }\n  &::after {\n    position: absolute;\n    display: block;\n    content: ' ';\n    top: 0;\n    left: 50%;\n    width: ", ";\n    height: ", ";\n    margin-left: -", ";\n    border-radius: 50%;\n    background: currentColor;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: ", ";\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LargeLoadingIndicator = exports.LoadingIndicator = exports.DiscreteLoadingIndicator = exports.BlockSpin = void 0;

var icons_1 = require("@ant-design/icons");

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var Block_1 = require("./Block");

var Typography_1 = require("./Typography");

var Container = styled_components_1.default.div(_templateObject(), function (props) {
  return props.theme['@size-s'];
});

var BlockSpin = function BlockSpin(props) {
  return react_1.default.createElement(Container, null, react_1.default.createElement(antd_1.Spin, Object.assign({}, props)));
};

exports.BlockSpin = BlockSpin;

function DiscreteLoadingIndicator(_ref) {
  var loading = _ref.loading;
  return react_1.default.createElement(LoadingContainer, {
    loading: loading
  }, react_1.default.createElement(icons_1.LoadingOutlined, null), react_1.default.createElement(Typography_1.BodySmall, {
    color: '@text-color-secondary'
  }, "Saving..."));
}

exports.DiscreteLoadingIndicator = DiscreteLoadingIndicator;

function LoadingIndicator(_ref2) {
  var size = _ref2.size;
  var theme = react_1.default.useContext(styled_components_1.ThemeContext);
  var sizePx = typeof size === 'number' ? size : size ? theme[size] ? parseFloat(theme[size].replace('px', '')) : undefined : undefined;
  if (sizePx !== undefined && isNaN(sizePx)) throw new Error("Invalid LoadingIndicator size '".concat(size, "'"));
  return react_1.default.createElement(LoadingIndicatorElement, {
    size: sizePx
  });
}

exports.LoadingIndicator = LoadingIndicator;
var SpinAnimation = (0, styled_components_1.keyframes)(_templateObject2());
var LoadingIndicatorElement = styled_components_1.default.div(_templateObject3(), function (props) {
  return props.size ? "".concat(props.size, "px") : '1em';
}, function (props) {
  return props.size ? "".concat(props.size, "px") : '1em';
}, SpinAnimation, function (props) {
  return props.size ? "".concat(props.size * 0.2, "px") : '0.2em';
}, function (props) {
  return props.size ? "".concat(props.size * 0.2, "px") : '0.2em';
}, function (props) {
  return props.size ? "".concat(props.size * 0.2, "px") : '0.2em';
}, function (props) {
  return props.size ? "".concat(props.size * 0.1, "px") : '0.1em';
});
var LoadingContainer = styled_components_1.default.div(_templateObject4(), function (props) {
  return props.loading ? 1 : 0;
}, function (props) {
  return props.theme['@text-color-secondary'];
}, function (props) {
  return props.theme['@size-xm'];
}, function (props) {
  return props.theme['@size-xs'];
});

function LargeLoadingIndicator(_ref3) {
  var message = _ref3.message;
  return react_1.default.createElement(Block_1.Block, {
    marginTop: '@size-l',
    marginBottom: '@size-l',
    style: {
      width: '100%'
    }
  }, react_1.default.createElement(Block_1.VSpaced, {
    align: 'center'
  }, react_1.default.createElement(LoadingIndicator, {
    size: '@size-l'
  }), react_1.default.createElement(Typography_1.BodyLarge, {
    color: '@text-color-secondary',
    style: {
      textAlign: 'center'
    }
  }, message)));
}

exports.LargeLoadingIndicator = LargeLoadingIndicator;